<template>
  <b-overlay
    :show="loading"
    rounded
    opacity="0.6"
    spinner
    spinner-variant="primary"
    class="recent-trades"
    @hidden="!loading"
  >
    <div class="recent-trades-wrapper" header-tag="header">
      <p v-if="$mq !== 'mobile'" class="header title-8">
        {{ $t('trade.recent-trades') }}
      </p>
      <div v-if="trades && trades.length" class="recent-trades-table">
        <table class="trade">
          <thead>
            <tr>
              <th>{{ $t('helper.date') }}</th>
              <th>
                {{ $t('order.slotted-price', { type: $t('order.complete') }) }}
              </th>
              <th>{{ $t('order.quantity') }}</th>
            </tr>
          </thead>
          <TransitionGroup tag="tbody" name="fade" id="scrollable-trades" class="scrollable container">
            <tr v-for="(trade, index) in trades.slice().reverse()" :key="index">
              <td>
                {{ trade.date | formatDate('time') }}
              </td>
              <td v-if="brand.stype === 1 || brand.bond_type === 200">
                {{ trade.MDEntryPx || trade.price | currency('', '₮') }}
              </td>
              <td v-else>
                {{
                  trade.MDEntryPx * 1000 ||
                  (trade.price * 1000) | currency('', '₮')
                }}
              </td>
              <td class="text-center">
                {{
                  trade.MDEntrySize || trade.size | currency('no-precision', '')
                }}
              </td>
            </tr>
          </TransitionGroup>
        </table>
      </div>
      <div class="py-5" v-else>
        <empty type="trade" />
      </div>
    </div>
  </b-overlay>
</template>

<script>
import Empty from '../Empty'
export default {
  components: {
    Empty,
  },
  props: {
    brand: {
      type: Object,
      required: true,
    },
    trades: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style src="./RecentTrades.scss" lang="scss" />
